import { render, staticRenderFns } from "./hero-brand.vue?vue&type=template&id=23e2f5de"
import script from "./hero-brand.vue?vue&type=script&lang=js"
export * from "./hero-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports